<template>
    <el-cascader
        :value="innerValue"
        :options="options"
        @input="handleInput"
        v-bind="$attrs"
        v-on="listeners"
    ></el-cascader>
</template>
<script>
import {isEqualArray} from '../../utils/tools';

const findPathInTree = (data, value, path, level, field) => {
    let finded = data.some(item => {
        path[level] = item;
        if (field.every(key => {
            return item[key] === value[key];
        })) {
            // 把后面的清除掉
            path.splice(level + 1);
            return true;
        }
        if (!item.children) {
            return false;
        }
        return findPathInTree(item.children, value, path, level + 1, field);
    });
    // 如果没找到，要把当前层级后面的删掉
    if (!finded) {
        path.splice(level);
    }
    return finded;
};

const isPlainData = data => {
    return data === null || data === undefined || data === '' ||
            (Array.isArray(data) && !data.length) ||
            (typeof data === 'object' && !Object.keys(data).length);
};

export default {
    name: 'XxCitySelect',
    props: {
        value: [Number, String, Object, Array],
        isPath: {
            type: Boolean,
            default: true
        },
        valueKey: {
            type: String,
            default: 'id'
        },
        labelKey: {
            type: String,
            default: 'originalFullName'
        },
        valueUseObject: {
            type: Boolean,
        },
        useFields: {
            type: Array
        },
        maxLevel: {
            type: Number
        },
        responseProcessor: {
            type: Function
        },
        data: {
            type: Array
        }
    },
    data() {
        return {
            sourceData: [],
            options: []
        };
    },
    watch: {
        data(val, oldVal) {
            if (!isEqualArray(val, oldVal)) {
                this.sourceData = val;
                this.options = this.formatToTree(val);
            }
        }
    },
    computed: {
        innerValue() {
            let value = this.value;
            if (isPlainData(value)) {
                return [];
            }
            if (this.valueUseObject) {
                value = this.getDataByField(this.options, value, this.useFields).map(item => item.value);
            } else if (!this.isPath) {
                value = this.getDataByField(this.options, {value}, ['value']).map(item => item.value);
            }
            return value;
        },
        listeners() {
            const {input, ...listeners} = this.$listeners;
            return listeners;
        }
    },
    created() {
        if (!this.data) {
            this.getData();
        } else {
            this.sourceData = this.data;
            this.options = this.formatToTree(this.data);
        }
    },
    methods: {
        getData() {
            const keyList = ['id', 'parentId', 'originalName', 'originalFullName', 'level', 'isLeaf'];
            this.$hGet('/api/auth/adminDivision/findAllInChina').then(res => {
                const list = [];
                this.$emit('loaded', res);
                res.forEach(item => {
                    const result = {};
                    keyList.forEach(key => {
                        result[key] = item[key];
                    });
                    const data = {
                        ...result,
                        value: item[this.valueKey],
                        label: item[this.labelKey]
                    };
                    if (!this.maxLevel || item.level <= this.maxLevel) {
                        list.push(data);
                    }
                });
                this.sourceData = this.responseProcessor ? this.responseProcessor(list) : list;
                this.options = this.formatToTree(list);
            });
        },
        formatToTree(data) {
            const result = [];
            data.forEach(item => {
                // 查找父节点
                const parent = data.find(item2 => item2.id === item.parentId);
                if (parent && parent.children) {
                    parent.children.push(item);
                } else if (parent) {
                    parent.children = [item];
                } else {
                    result.push(item);
                }
            });
            return result;
        },
        handleInput(val) {
            let result = val;
            const leafValue = val[(val || []).length - 1];
            let leafData;
            if (leafValue && (this.valueUseObject || !this.isPath)) {
                leafData = this.sourceData.find(item => item.value === leafValue);
            }
            if (this.valueUseObject) {
                result = leafData && this.useFields.reduce((prev, cur) => {
                    prev[cur] = leafData[cur];
                    return prev;
                }, {});
            } else if (!this.isPath) {
                result = leafValue;
            }
            this.$emit('input', result);
        },
        getDataByField(data, value, useFields) {
            const path = [];
            findPathInTree(data, value, path, 0, useFields);
            return path;
        }
    }
};
</script>
<style lang="scss" scoped>
</style>
